/**
 * Report path helpers for Scatter / Probability History explore pages.
 */

/** Scatter History component lives under project/all/explore; rewrite legacy report paths from the pages API. */
export function remapScatterHistoryToExplorePath(basePathNoExt: string): string {
  const norm = (basePathNoExt || '').replace(/\\/g, '/').trim();
  return norm.replace(
    /\/project\/all\/reports\/ScatterHistory$/i,
    '/project/all/explore/ScatterHistory'
  );
}

/** `user_objects.parent_name` for Scatter History saved charts (builder + explore page). */
export const SCATTER_HISTORY_PARENT_NAME = 'scatter_history';

/** Normalize builder/parent keys to scatterhistory | probabilityhistory. */
export function normalizeHistoryBuilderKey(builderType: string): 'scatterhistory' | 'probabilityhistory' | null {
  const key = (builderType || '').toLowerCase().replace(/\s+/g, '').replace(/_/g, '');
  if (key === 'scatterhistory') {
    return 'scatterhistory';
  }
  if (key === 'probabilityhistory') {
    return 'probabilityhistory';
  }
  return null;
}

/** Stable explore component path when pages API menu is not loaded yet. */
export function getStableProjectHistoryExplorePath(className: string, builderType: string): string {
  const cn = (className || '').trim();
  if (!cn) {
    return '';
  }
  const kind = normalizeHistoryBuilderKey(builderType);
  if (kind === 'scatterhistory') {
    return `${cn}/project/all/explore/ScatterHistory`;
  }
  if (kind === 'probabilityhistory') {
    return `${cn}/project/all/explore/ProbabilityHistory`;
  }
  return '';
}

/** True when a pages API `file_path` targets the ScatterHistory report module. */
export function isScatterHistoryComponentPath(filePath: string | undefined | null): boolean {
  const norm = remapScatterHistoryToExplorePath(
    (filePath || '').replace(/\.(jsx|tsx|js|ts)$/i, '').replace(/\\/g, '/').trim()
  ).toLowerCase();
  return /\/project\/all\/explore\/scatterhistory$/i.test(norm)
    || /\/project\/all\/reports\/scatterhistory$/i.test(norm);
}

/** Probability History component lives under project/all/explore; rewrite legacy report paths from the pages API. */
export function remapProbabilityHistoryToExplorePath(basePathNoExt: string): string {
  const norm = (basePathNoExt || '').replace(/\\/g, '/').trim();
  return norm.replace(
    /\/project\/all\/reports\/ProbabilityHistory$/i,
    '/project/all/explore/ProbabilityHistory'
  );
}

/** `user_objects.parent_name` for Probability History saved charts (builder + explore page). */
export const PROBABILITY_HISTORY_PARENT_NAME = 'probability_history';

/** True when a pages API `file_path` targets the ProbabilityHistory report module. */
export function isProbabilityHistoryComponentPath(filePath: string | undefined | null): boolean {
  const norm = remapProbabilityHistoryToExplorePath(
    (filePath || '').replace(/\.(jsx|tsx|js|ts)$/i, '').replace(/\\/g, '/').trim()
  ).toLowerCase();
  return /\/project\/all\/explore\/probabilityhistory$/i.test(norm)
    || /\/project\/all\/reports\/probabilityhistory$/i.test(norm);
}
